var body = function body(_ref) {
  var dwd = _ref.dwd,
      wfaacl = _ref.wfaacl,
      encses = _ref.encses;
  if (!dwd || !wfaacl || !encses) throw new TypeError('dwd, wfaacl, & encses are required');
  return "dwd=".concat(dwd, "&wfaacl=").concat(wfaacl, "&encses=").concat(encses);
};

module.exports = function (axios, skywardURL) {
  return function (auth) {
    if (!axios || !skywardURL) throw new TypeError('axios & skywardURL are required');
    return axios({
      url: '../sfgradebook001.w',
      baseURL: skywardURL,
      method: 'post',
      data: body(auth)
    });
  };
};